import { render, staticRenderFns } from "./shopOrderCart.vue?vue&type=template&id=af18db92&scoped=true"
import script from "./shopOrderCart.vue?vue&type=script&lang=js"
export * from "./shopOrderCart.vue?vue&type=script&lang=js"
import style0 from "./shopOrderCart.vue?vue&type=style&index=0&id=af18db92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af18db92",
  null
  
)

export default component.exports